export const sidebarItems = [
    {
        name: "Dashboard",
        path: "/dashboard",
    },
    {
        name: "New Applicants",
        path: "/new-applicants",
    },
     {
        name: "Incomplete Applications",
        path: "/incomplete-applicants",
    },
    {
        name: "Successful",
        path: "/successful",
    },
    {
        name: "Rejected",
        path: "/rejected",
    },
    {
        name: "Refund Cases",
        path: "/refund-cases",
    },
    {
        name: "Appeals",
        path: "/appeals",
        divider: true,
    },
    {
        name: "CPD Submissions",
        path: "/cpd-submission",
        // divider: true,
    },
    {
        name: "Membership Status",
        path: "/membership-status",
    },
    {
        name: "Renewals",
        path: "/renewals",
        divider: true,
    },
    {
        name: "ATPs",
        path: "/atp",
    },
    {
        name: "Activities",
        path: "/activities",
    },
    {
        name: "Reports",
        path: "/reports",
        children: [
            { name: "New Applicants", path: "reports/new-applicants" },
            { name: "CPD Analysis", path: "/reports/cpd-analysis" },
            { name: "Membership Analysis", path: "/reports/membership-analysis" },
            { name: "Renewals", path: "/reports/renewals" },
            { name: "ATPs", path: "/reports/atps" },
            { name: "Interview Report", path: "/reports/interview-scheduled" },
            { name: "Export Report", path: "/reports/export-reports" },
        ],
    },
    {
        name: "CPD Hours",
        path: "/cpd-hours",
    },
    {
        name: "Bulk Registrations",
        path: "/bulk-registrations",
        divider: true,
    },
];
